import toNumber from 'lodash/toNumber'
import toPairs from 'lodash/toPairs'
import type { WireValidationErrorMap } from '@klear/schema/wire/trpc-form-errors'

const PROPOSAL_PATH = /(?:^|\.)proposals\.(\d+)\.([A-Za-z]+)$/

export type DraftFieldError = { ordinal: number; field: string; message: string }

export function draftFieldErrors(
  errorMap: WireValidationErrorMap,
  editedOrdinals: readonly number[]
): DraftFieldError[] {
  const errors: DraftFieldError[] = []
  for (const [path, message] of toPairs(errorMap)) {
    const match = PROPOSAL_PATH.exec(path)
    if (match === null) continue
    const ordinal = editedOrdinals[toNumber(match[1])]
    if (ordinal === undefined) continue
    errors.push({ ordinal, field: match[2] ?? '', message })
  }
  return errors
}

export function unmappedErrorMessages(errorMap: WireValidationErrorMap, editedOrdinals: readonly number[]): string[] {
  const messages: string[] = []
  for (const [path, message] of toPairs(errorMap)) {
    const match = PROPOSAL_PATH.exec(path)
    if (match !== null && editedOrdinals[toNumber(match[1])] !== undefined) continue
    messages.push(message)
  }
  return messages
}
